export const HEADER_OFFSET = 84;

export function smoothScrollToId(id) {
  if (typeof document === "undefined") return false;
  const el = document.getElementById(id);
  if (!el) return false;
  const top = el.getBoundingClientRect().top + window.pageYOffset - HEADER_OFFSET;
  window.scrollTo({ top: top < 0 ? 0 : top, behavior: "smooth" });
  return true;
}

export function smoothScrollToTop() {
  if (typeof window === "undefined") return;
  window.scrollTo({ top: 0, behavior: "smooth" });
}
